import { useState, useEffect } from "react";

const imageModules = import.meta.glob(
  "/src/assets/carousel/*.{png,jpg,jpeg,webp,PNG,JPG,JPEG,WEBP}",
  { eager: true }
) as Record<string, { default: string }>;

const slides = Object.values(imageModules).map((m) => m.default);

/** How long each slide is held before the next one fades in. */
const SLIDE_DURATION_MS = 9000;

const LoginCarousel = () => {
  const [current, setCurrent] = useState(0);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (slides.length <= 1) return;
    const timer = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % slides.length);
        setFading(false);
      }, 400);
    }, SLIDE_DURATION_MS);
    return () => clearInterval(timer);
  }, []);

  if (slides.length === 0) return null;

  return (
    <div className="relative flex flex-col items-center gap-4">
      <img
        key={current}
        src={slides[current]}
        alt={`Feature ${current + 1}`}
        className="rounded-2xl shadow-2xl max-h-[72vh] max-w-full w-auto h-auto transition-opacity duration-500"
        style={{ opacity: fading ? 0 : 1 }}
      />

      {slides.length > 1 && (
        <div className="flex justify-center gap-2">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`h-2 rounded-full transition-all duration-300 ${
                i === current ? "w-6 bg-white" : "w-2 bg-white/50"
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default LoginCarousel;
